




























































































































import {Prop, Watch} from "vue-property-decorator";
import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Achat, LongueursAchat, BoisType} from '@/models';
import {Timeout, WatchObjectProperties} from '@/shared/decorator';
import axios from "axios";
import InputBoisType from '@/components/Input/BoisType.vue';
import InputLongueursAchat from '@/components/Input/LongueursAchat.vue';

import { icon, latLng } from "leaflet";
import { LMap, LMarker, LTileLayer, LControl, LTooltip, LPopup, LCircleMarker, LIcon  } from "vue2-leaflet";
import storeToken from "@/stores/modules/token";
import {Token, User} from "@/models";
//import {} from '@types/googlemaps';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import { Icon } from 'leaflet';

@Component({
	components: {
		LMap,
		LTileLayer,
		LMarker,
		LIcon,
		LControl,
		LTooltip,
		LPopup,
		LCircleMarker,
		InputBoisType,
		InputLongueursAchat,
	}
})
export default class PrestationMapView extends Vue {

	@Stored(() => storeToken) private token: Token;

	provider = new OpenStreetMapProvider();
	lat = 46.08014897989135;
	lng = 4.386728978266652;
	center;
	zoom = 7;
	//url = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
	url = 'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}';
	urlsat = 'https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}';
	attribution =
		'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';
	showMap = false;
	private showMapSatellite : boolean  = false;
	private opacitySat : number = 0;
	markers;
	subdomains = ["mt0", "mt1", "mt2", "mt3"];

	private SurPied : boolean  = true;
	private BordDeRoute : boolean  = true;
	private TempsSec : boolean  = false;
	public boisType:     BoisType = null;
	public boisSize:     LongueursAchat = null;

	private filtreSurPiedText  = '';
	private filtreBordDeRouteText  = '';
	private filtreTempsSecText  = '';
	private filtreboisTypeText  = '';
	private filtreboisSizeText  = '';

	async mounted() {
		this.LoadData();
		this.center = latLng(this.lat, this.lng);
		var greenIcon = icon({
				iconUrl: '/img/drapeau.png',
				shadowUrl: '',

				iconSize:     [34, 37], // size of the icon
				shadowSize:   [50, 64], // size of the shadow
				iconAnchor:   [0, 0], // point of the icon which will correspond to marker's location
				shadowAnchor: [4, 62],  // the same for the shadow
				popupAnchor:  [-3, -76] // point from which the popup should open relative to the iconAnchor
			});
		const searchControl = GeoSearchControl({
			provider: new OpenStreetMapProvider(),
			marker: {
					// optional: L.Marker    - default L.Icon.Default
					icon: greenIcon,
					draggable: false,
				},
			});

		const map = this.$refs['myMap'] as LMap;
		map.mapObject.addControl(searchControl);
	}

	@Watch('showMapSatellite')
	onOpacitySatChanged(value: boolean, oldValue: boolean) {
		if (this.showMapSatellite == true)
			this.opacitySat = 1;
		else
			this.opacitySat = 0;
	}

	@Watch('SurPied')
	@Watch('BordDeRoute')
	@Watch('TempsSec')
	@Watch('boisType')
	@Watch('boisSize')
	onPropertyChanged(value: string, oldValue: string) {
		this.LoadData();
	}
	private async CalculFiltre()
	{
		if (this.SurPied == true)
			this.filtreSurPiedText = '1';
		else
			this.filtreSurPiedText = '0';

		if (this.BordDeRoute == true)
			this.filtreBordDeRouteText = '1';
		else
			this.filtreBordDeRouteText = '0';

		if (this.TempsSec == true)
			this.filtreTempsSecText = '1';
		else
			this.filtreTempsSecText = '0';

		if (this.boisType)
			this.filtreboisTypeText  = this.boisType.id.toString();
		else
			this.filtreboisTypeText  = '0';

		if (this.boisSize)
			this.filtreboisSizeText  = this.boisSize.id.toString();
		else
			this.filtreboisSizeText  = '0';
	}

	private async LoadData()
	{
		this.CalculFiltre();

		await axios.get(process.env.VUE_APP_BACK_BASE_URL + "/api/achats/map/" + this.filtreSurPiedText + "/" + this.filtreBordDeRouteText + "/" + this.filtreTempsSecText + "/" + this.filtreboisTypeText + "/" + this.filtreboisSizeText + "?token=" + this.token.id, {}).then(async response => {
			this.markers = await response.data;
		});
		/*await axios.get(process.env.VUE_APP_BACK_BASE_URL + "/api/chantiers/maps/" + this.filtreContratText + "/" + this.filtreCommuneText + "/" + this.filtreClientText + "/" + this.filtreAvecGrumesText + "/" + this.filtreAvecBillonsText + "/" + this.filtreToutFiniText + "?token=" + this.token.id, {}).then(async response => {
			this.markers = await response.data;
		});*/

		this.$forceUpdate();
	}


	private ClearContrat() : void {
		this.LoadData();
	}

	private ClearCommune() : void {
		this.LoadData();
	}

	private ClearClient() : void {
		this.LoadData();
	}
}
